import type { RootScope } from '../../types';

import { ChatButtonController } from './lead.popup.chat.button.controller';
import template from './lead.popup.chat.button.html';

export const chatButton: angular.IDirectiveFactory = (
  $rootScope: RootScope,
) => ({
  restrict: 'A',
  controller: ChatButtonController,
  controllerAs: 'vm',
  bindToController: true,
  scope: {
    lead: '=',
    /**
     * lead instance or lead.additional_contact to init button for
     */
    contact: '=',
  },
  template,
  link: ($scope, $el, attr, vm: ChatButtonController) => {
    // hide till we will know that chat is available
    $el.hide();

    vm.$el = $el;
    vm.fallbackCountry = $rootScope.getDefaultCountry();
    vm.locale = $rootScope.company.ui_locale;
    vm.email = $rootScope.userEmail;
  },
});

chatButton.$inject = ['$rootScope'];
